export class Organization {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    name!: string;
    name_en!: string;
    name_ka!: string;
    name_ru!: string;
    hourly_salary_title!: string;
    hourly_salary_id!: string;
    hourly_invoicable_title!: string;
    hourly_invoicable_id!: string
    customer_shifts_editable_after!: number;
    customer_shifts_not_editable_before!: number;
    employee_shifts_editable_after!: number;
    street_address!: string;
    office!: string;
    city!: string;
    postal_code!: string;
    lat!: string;
    long!: string;
    tbc_api_key!: string;
    tbc_client_id!: string;
    tbc_api_secret!: string;
    checkin_warnings_user_id!: number;
    new_customer_allow_ordering_with_cash!: boolean
    new_customer_allow_ordering_with_invoice!: boolean
    default_km_expense!: number
    reserve_grace_period!: number
    customer_order_start_time!: string
    customer_order_end_time!: string
    customer_order_step!: number
    shift_padding!: number
    minimum_order!: number
    daily_salary_title!: string
    daily_salary_title_en!: string
    daily_salary_title_ka!: string
    daily_salary_title_ru!: string
    daily_salary_id!: string
    monthly_salary_title!: string
    monthly_salary_title_en!: string
    monthly_salary_title_ka!: string
    monthly_salary_title_ru!: string
    monthly_salary_id!: string
    // LANGUAGE RELATED
    customer_tnc_en!: string
    customer_tnc_ka!: string
    customer_tnc_ru!: string
    company_id!: string
    vat_id!: string
    homepage!: string
    customer_app_link_android!: string
    customer_app_link_ios!: string
    customer_app_link_web!: string
    allow_public_ordering!: boolean
    customer_order_margin!: number
    customer_order_monday!: boolean
    customer_order_tuesday!: boolean
    customer_order_wednesday!: boolean
    customer_order_thursday!: boolean 
    customer_order_friday!: boolean
    customer_order_saturday!: boolean
    customer_order_sunday!: boolean
    card_test_mode!: boolean
    receipt_number!: number
    balance_ge_base_url!: string
    balance_ge_username!: string
    balance_ge_password!: string
    balance_ge_employee_name_format!: string
    payment_api!: string
    fcm_config!: string
    invoice_as_employee!: boolean
    show_public!: boolean
    country_code!: string
    api_url!: string
    ws_url!: string
    allow_employee_pricing!: boolean
    employee_contract_document_id!: number
    email_from_name!: string
    allow_updates_assignments!: boolean
    allow_updates_message_templates!: boolean
    allow_updates_products!: boolean
    allow_updates_prompts!: boolean
    allow_updates_badges!: boolean
    languages!: string
    employee_default_subscription_price!: number
    employee_default_subscription_days!: string
    currency!: string
    service_fee_title!: string
    affiliate_bank_link!: string
    affiliate_bank_name!: string
    affiliate_accountant_link!: string
    affiliate_accountant_name!: string
    national_business_register_link!: string
    national_business_register_name!: string
    facebook_graph_api_page_id!: string;
    facebook_graph_api_access_token!: string;
    facebook_graph_api_lang!: string;
    facebook_graph_api_enabled!: boolean;
    employee_manual!: string;
    allow_updates_settings!: boolean;
    country_local!: string;
    privacy_policy!: string
    employee_invite_bonus_amount: number
    employee_app_link_web!: string
    employee_app_link_ios!: string
    employee_app_link_android!: string
    country!: string
    osm_tile_url!: string
    country_area!: string
}

  